import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import { api } from "@/lib/api-client"
import type { TaskCategory } from "@/lib/types"

export function useTaskCategories() {
  return useQuery({
    queryKey: ["task-categories"],
    queryFn: () => api.get<{ data: TaskCategory[] }>("/api/v1/task_categories"),
  })
}

export function useCreateTaskCategory() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: { name: string; color: string; sort_order?: number }) =>
      api.post<{ data: TaskCategory }>("/api/v1/task_categories", data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["task-categories"] })
    },
  })
}

export function useUpdateTaskCategory() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: { name?: string; color?: string; sort_order?: number } }) =>
      api.patch<{ data: TaskCategory }>(`/api/v1/task_categories/${id}`, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["task-categories"] })
    },
  })
}

export function useDeleteTaskCategory() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => api.delete(`/api/v1/task_categories/${id}`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["task-categories"] })
    },
  })
}
